export function splitRequestText(text,requestId) {
 const value=typeof text==='string'?text:'';
 const match=value.match(/\s*\((?:Request|request):?\s+([A-Za-z0-9_.:-]{1,160})\)\s*$/);
 return {text:match?value.slice(0,match.index):value,requestId:requestId || match?.[1] || null};
}
